<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-dsm" />
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  name: 'process-dbadapter',
  props: {
    comId: {
      default: '',
    },
    comTp: {
      default: 'DBA',
    },
    isHistory: {
      default: false,
    },
    isDisable: {
      default: false,
    },
    manage: {
      default: false,
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      nodeId: '',
      hideItem: true,
      hideIcon: 'fa fa-caret-down',
      hideText: 'Expand',
      formData: {
        byProcSetup: true,
        dba_id: '',
        dba_child_id: '',
        dba_name: '',
        from_to: '',
        config_module: '',
        dba_mapper_id: '',
        mapper_name: '',
        dba_type: '',
        dba_conf_id: '',
        config_name: '',
        sql_grp_id: '',
        sql_grp_name: '',
      },
      checkDialogInfo: '',
      dtSourceTpList: [
        { text: 'D2D', value: 'D2D' },
        { text: 'D2J', value: 'D2J' },
        { text: 'J2D', value: 'J2D' },
      ],
      childList: [],
      parentData: {},
      formEmit: {
        comTp: 'DBA',
        comId: '',
        nodeId: '',
      },
    };
  },
  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },
  watch: {
    comId() {
      return this.comId;
    },
  },
  methods: {
    resetForm() {
      this.formData = {
        byProcSetup: true,
        dba_id: '',
        dba_child_id: '',
        dba_name: '',
        from_to: '',
        config_module: '',
        dba_mapper_id: '',
        mapper_name: '',
        dba_type: '',
        dba_conf_id: '',
        config_name: '',
        sql_grp_id: '',
        sql_grp_name: '',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.dba_child_id = id;
        if (!this.formData.dba_child_id) {
          this.resetForm();
          return;
        }
        this.changeDBAdapter();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    openXmlMapperListDialog() {
      if (this.formData.dba_mapper_id) {
        EventBus.$emit('openXmlMapperListDialog');
      }
    },
    openSQLGroupDialog() {
      if (this.formData.sql_grp_id) {
        if (this.formData.dba_type === 'D2D') {
          EventBus.$emit('open-dialog-modify-d2d', this.formData);
        } else {
          EventBus.$emit('open-dialog-modify', this.formData);
        }
      }
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.formData.dba_child_id = this.comId;
        if (this.formData.dba_child_id !== '') {
          this.selectDBADetail();
          if (this.comTp == 'DBAC') {
            const id = this.comId;
            let index = this.dbAdapterList.filter((e) => e.dba_child_id == id)[0].dba_id;
            let data = this.dbAdapterList.findIndex((e) => e.dba_child_id == index);
            if (data > -1) {
              this.parentData = Object.assign({}, this.dbAdapterList[data]);
              this.parentData.dba_name = 'Group source : ' + this.parentData.dba_name;
            }
          }
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    selectDBADetail() {
      this.rulesComId = [];
      if (this.formData.dba_child_id !== '' && this.formData.dba_child_id !== undefined) {
        const id = this.formData.dba_child_id;
        let index = this.dbAdapterList.findIndex((e) => e.dba_child_id == id);
        if (index > -1 && (this.manage || this.isHistory)) {
          this.formData = Object.assign({}, this.dbAdapterList[index]);
          this.formEmit = {
            comId: this.formData.dba_child_id,
            nodeId: this.nodeId,
            comName: this.formData.dba_name,
            comTp: this.comTp,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        } else {
          this.resetForm();
        }
      }
    },
    changeDBAdapter() {
      const id = this.formData.dba_child_id;
      let index = this.dbAdapterList.findIndex((e) => e.dba_child_id == id);
      if (index > -1) {
        this.formData = Object.assign({}, this.dbAdapterList[index]);

        this.formEmit = {
          comId: this.formData.dba_child_id,
          nodeId: this.nodeId,
          comName: this.formData.dba_name,
          comTp: this.comTp,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
        EventBus.$emit('create-dba-child', this.formEmit);
      }
    },
    collapse(val) {
      this.hideItem = val;
      this.hideText = this.hideItem ? 'Expand' : 'Collapse';
    },
    close() {
      EventBus.$emit('close', this.nodeId);
    },
  },
  computed: {
    dbAdapterList() {
      let data = [];
      if (this.comTp === 'DBAC') {
        data = this.$store.getters.dataDBASelectBox;
      } else {
        this.$store.getters.dataDBASelectBox.forEach((tmpDba) => {
          if (tmpDba.dba_type !== 'D2D' || tmpDba.dba_id === tmpDba.dba_child_id) {
            data.push(tmpDba);
          }
        });
      }
      return data;
    },
  },
};
</script>
